import withSpacing from '../../decorators/withSpacing/index';
import Radio from './Radio';
export default withSpacing(Radio);
export { RadioContext } from './Radio';
//# sourceMappingURL=index.js.map